// Layout.jsx
import React from 'react';
import './Layout.css';
import Header from './Header';
// import TawkToWidget from "./TawkToWidget";
import Footer from './Footer';
import SocialIcons from './Socialicons';
import { Outlet } from 'react-router-dom';
import ScrollToTopButton from "./ScrollToTopButton";

function Layout() {
    return (
        <div className="page-wrapper">
            <Header />
            <SocialIcons />
            <main className="page-content1">
                <Outlet />
            </main>
            <Footer />
          {/* <TawkToWidget/> */}
            <ScrollToTopButton />
        </div>
    );
}

export default Layout;
